export const SENSOR1ID = "zHaq3vOjGXvOTvq6necC%2BxbmtXOjJ5n3legMJ4nu5ISmJ5em"
export const SENSOR2ID = "m3Wn0KCnGH7OTK7snecCrhK6tXCgJ5v3leIMcNW8vtH3KsT9"